import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { Images } from "./../../assets/common";
import { logout } from "./../../constants/function";
import { useHistory } from "react-router-dom";
export default function WaitList() {
  const history = useHistory();
  const handleLogout = () => {
    logout();
    history.push("/");
  };
  return (
    <Box sx={{ position: "relative", height: "100vh" }}>
      <IconButton
        onClick={() => handleLogout()}
        sx={{ marginTop: "20px", float: "right" }}
      >
        <img src={Images.logout} alt="logout" />
      </IconButton>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          maxWidth: "350px",
          position: "absolute",
          top: "0",
          bottom: "0",
          left: "0",
          right: "0",
          margin: "auto",
          padding: "20px",
        }}
      >
        <Typography
          sx={{
            fontFamily: '"Anton", sans-serif',
            fontSize: "45px",
            textAlign: "center",
          }}
        >
          SIKI
        </Typography>
        <Typography sx={{ textAlign: "center" }}>
          Thank you for joining SIKI.
        </Typography>
        <Typography sx={{ textAlign: "center" }}>
          You are now currently on the waitlist. Please check back as we are
          onboarding more users everyday.
        </Typography>
      </Box>
    </Box>
  );
}
